export default [
  {
    path: 'certificados',
    name: 'certificados',
    component: () => import('./views/CertificadosView.vue'),
    meta: { 
      requiresAuth: true,
      title: 'Certificados' ,
      menuResource: 'CERTIFICADOS' 
    },
  },
]